import { useStrapiGet } from 'src/shared/composables/useStrapiApi';
import { useAuth } from 'src/boot/auth';

const { signIn } = useAuth();

export function useChildUserLogin() {
  const login = async (code: string) => {
    console.log(code);
    const { execute, data } = useStrapiGet('users-permissions/users/child/login', {
      login_token: code,
    });

    try {
      await execute();
      if (data.value?.child?.jwt) await signIn(data.value.child.jwt);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    login,
  };
}
